import { Box, Heading, Stack, Text } from "@vinomofo/components";
import { LinkTo, StorefrontImage } from "../../types";

import { Button } from "../button";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import styled from "styled-components";
import { invert } from "polished";

const DEFAULT_BACKGROUND_COLOR = "darkMofo";

export interface BannerProps {
  __typename?: string;
  bannerTitle?: string;
  htmlBannerTitle?: string;
  bodyText?: string;
  tagline?: string;
  bodyTextColor?: string;
  backgroundImage?: StorefrontImage;
  backgroundImageMedium?: StorefrontImage;
  backgroundImageSmall?: StorefrontImage;
  titleColor?: string;
  hero?: boolean;
  contentPosition?: "Left" | "Center" | "Right";
  primaryCta: {
    buttonColour: string;
    buttonBorderColor: string;
    buttonTextColor: string;
    buttonHoverBorderColor: string;
    buttonHoverBackgroundColor: string;
    buttonHoverTextColor: string;
    label: string;
    linkTo: LinkTo;
  };
}

export const BannerButton = styled(Button)<{ backgroundColor: string }>`
  background: none;
  &:hover {
    background-color: ${({ backgroundColor }) => backgroundColor};
    border-color: ${({ backgroundColor }) => backgroundColor};
    color: ${({ backgroundColor }) => invert(backgroundColor)};
  }
`;

export const Banner = ({
  bannerTitle,
  bodyText,
  bodyTextColor,
  backgroundImage,
  backgroundImageMedium,
  backgroundImageSmall,
  titleColor,
  hero = false,
  primaryCta,
}: BannerProps): JSX.Element => {
  const ctaLink = primaryCta?.linkTo?.slug || primaryCta?.linkTo?.url;

  const BannerContent = (
    <Box
      width={"100%"}
      textAlign={"left"}
      marginRight={"auto"}
      marginLeft={0}
      height={hero ? "100%" : "50%"}
      position="relative"
      padding={5}
    >
      {backgroundImage && (
        <Box
          textAlign="center"
          width="100%"
          display={["none", "none", "block"]}
        >
          <GatsbyImage
            image={backgroundImage}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center center",
            }}
            alt=""
          />
        </Box>
      )}
      {backgroundImageMedium && (
        <Box
          textAlign="center"
          width="100%"
          display={["none", "block", "none"]}
        >
          <GatsbyImage
            image={backgroundImageMedium}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center center",
            }}
            alt=""
          />
        </Box>
      )}
      {backgroundImageSmall && (
        <Box
          textAlign="center"
          width="100%"
          display={["block", "none", "none"]}
        >
          <GatsbyImage
            image={backgroundImageSmall}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              width: "100%",
              height: "max-content",
              objectFit: "cover",
              objectPosition: "center center",
            }}
            alt=""
          />
        </Box>
      )}

      <Box
        width="50%"
        height="100%"
        position="relative"
        display="flex"
        alignItems="center"
      >
        <Stack space={3}>
          <Heading variant={hero ? "xxl" : "sm"} color={titleColor}>
            {bannerTitle}
          </Heading>
          <Text color={bodyTextColor} variant={hero ? "md" : "sm"}>
            {bodyText}
          </Text>
          {/* {hero && (
            <Link
              to={ctaLink}
              style={{
                left: "50%",
                top: "80%",
                position: "absolute",
                width: "100%",
              }}
            >
              {primaryCta && (
                <Button
                  variant="outline"
                  borderColor={
                    primaryCta.buttonBorderColor || DEFAULT_BACKGROUND_COLOR
                  }
                  backgroundColor={
                    primaryCta.buttonColour || DEFAULT_BACKGROUND_COLOR
                  }
                  color={primaryCta.buttonTextColor || "white"}
                  hoverBorderColor={primaryCta.buttonHoverBorderColor}
                  hoverBackgroundColor={primaryCta.buttonHoverBackgroundColor}
                  hoverTextColor={primaryCta.buttonHoverTextColor || "white"}
                  isCTA
                  label={primaryCta.label}
                  left={["50%", "50%", 0]}
                  top={["80%", "80%", 0]}
                  position={["absolute", "absolute", "relative"]}
                  width={["100%", "100%", "auto"]}
                >
                  {primaryCta.label}
                </Button>
              )}
            </Link>
          )} */}
        </Stack>
      </Box>
    </Box>
  );

  return ctaLink ? (
    <Link
      to={ctaLink}
      style={{
        textDecoration: "none",
        display: "block",
        width: "100%",
        height: "100%",
      }}
    >
      {BannerContent}
    </Link>
  ) : (
    BannerContent
  );
};
